import store from './store'
// import $router from './router'
// import $swal from 'sweetalert2'

window.appPush = (result) => {
  // $swal.fire(JSON.stringify(result))
  if (result) {
    store.commit('device/setCallback', result)
    const { route } = result
    if (route) {
      const { flutter_inappwebview, webToLoadUrl } = window
      if (flutter_inappwebview) {
        flutter_inappwebview.callHandler('webToLoadUrl', route)
      } else if (webToLoadUrl) {
        webToLoadUrl.postMessage(route)
      }
    }
  }
}

window.setDeviceInfo = (info) => {
  store.commit('device/setInfo', info)
}
